import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { UdyogLogo } from "@/components/UdyogLogo";
import { Loader2 } from "lucide-react";
import NotFound from "@/pages/NotFound";

export default function Invite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/invites/${token}`);
        if (!data?.room_name) throw new Error("Invalid invite");
        // Pass the invitee's name/WhatsApp via URL params. Meeting.jsx strips
        // them from the address bar on mount so nothing personal ever leaks.
        const qs = new URLSearchParams();
        if (data.user_name) qs.set("name", data.user_name);
        if (data.whatsapp) qs.set("wa", data.whatsapp);
        const suffix = qs.toString() ? `?${qs.toString()}` : "";
        nav(`/meet/${data.room_name}${suffix}`, { replace: true, state: { fromInvite: true } });
      } catch (e) {
        if (e?.response?.status === 404) {
          setNotFound(true);
          return;
        }
        setErr(formatApiError(e) || "This invite link isn't valid.");
      }
    })();
  }, [token, nav]);

  if (notFound) return <NotFound />;

  return (
    <div className="min-h-screen udyog-grid-bg flex items-center justify-center px-4">
      <div className="text-center">
        <UdyogLogo size={44} showTagline className="justify-center mb-6" />
        {err ? (
          <div className="text-red-400 text-sm max-w-sm">{err}</div>
        ) : (
          <div className="flex items-center justify-center gap-3 text-neutral-400">
            <Loader2 className="w-5 h-5 animate-spin text-emerald-400" /> Opening your meeting…
          </div>
        )}
      </div>
    </div>
  );
}
